import React from 'react';
import { array } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Card from '../Card/Card';

const propTypes = {
  countries: array.isRequired,
  intl: intlShape.isRequired,
};

const defaultProps = {
  countries: [],
  intl: function() { },
};

const getTitle = (intl) => intl.formatMessage({
  id: 'offer.geo.forbidden',
  defaultMessage: 'Forbidden Geo',
});

const getLabel = (intl) => intl.formatMessage({
  id: 'offer.geo.show-all',
  defaultMessage: 'Display all countries',
});

const OfferForbiddenGeoList = ({ countries, intl, collapsing }) => (
  <Card.Collapsible title={getTitle(intl)} collapsing={collapsing} label={getLabel(intl)} className="offer-forbidden-geo-list" items={countries} />
);

OfferForbiddenGeoList.propTypes = propTypes;
OfferForbiddenGeoList.defaultProps = defaultProps;

export default injectIntl(OfferForbiddenGeoList);
